import React, {useState} from 'react';
import EditIcon from '../../assets/images/edit.svg';
import CardIcon from '../../assets/images/noti.svg';
import PushOnIcon from '../../assets/images/chaked-profile.svg';
import PushOffIcon from '../../assets/images/uncheked-profile.svg';
import Iconfile from "../../assets/images/file.svg";
import ReportIssueIcon from "../../assets/images/phone.svg";
import ChangePasswordIcon from "../../assets/images/password.svg";
import ProfileMainIcon from "../../assets/images/userImg.svg";
import FaqsIcon from "../../assets/images/faq.svg";
import { useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import verified from "../../assets/images/verified.svg";
import logout from '../../assets/images/logout.svg';
import { Put} from '../../Api/ApiMethods.js';
import {
  rqstOtpForEmailVerificationUrl,
  rqstOtpForPhoneVerificationUrl
 } from '../../Routes/ApiRoutes';


export default function UserProfile() {
    const adminDetails = useSelector((state) => state.auth.adminData);
    const [pushNoti, setPushNoti] = useState(true);
    const history = useHistory()

    const handleVerifyMail = () => {
        try {
            Put(rqstOtpForEmailVerificationUrl, { 'email' : adminDetails.email})
            .then(response => {
                if(response.success)                
                {
                    history.push({ 
                    pathname: '/verifyEmail',
                    state : response.data
                    })
                }
            })
            .catch(error => {
            toast.error(error.error)
            })
        }catch (error) {
            console.log(error);
        }
    }

    const handleVerifyPhone = () => {
        try {
            Put(rqstOtpForPhoneVerificationUrl, { 'phone' : adminDetails.phone})
            .then(response => {
                if(response.success)                
                {       
                history.push({ 
                    pathname: '/verifyPhone',
                    state : response.data
                    })
                }
            })
            .catch(error => {
            toast.error(error.error)
            })
        }catch (error) {
            console.log(error);
        }
    }

    return (
        <section className="profile-wrapper">
            <div className="container">
                <div className="profile-details">
                    <div className="row flexRowReverse no-gutters">
                        <div className="col-md-4 col-sm-12 col-12 padding-lt">
                            <div className="profile-img">
                                <img className="img-fluid" src={adminDetails.image ? adminDetails.image : ProfileMainIcon} />
                            </div>
                        </div>
                        <div className="col-md-8 col-sm-12 col-12 padding-rt">
                            <div className="profile">
                                <div className="profile-head">
                                    <div className="payment">
                                        <h3 className="user-name">{adminDetails.name}</h3>
                                    </div>
                                    <div className="new-payment">
                                        
                                        <button style={{float:'right'}} className="edit-profile"
                                            onClick={() => history.push(`/profile/editProfile`)}  >
                                            <span>Edit profile</span>
                                            <img src={EditIcon} />
                                        </button>
                                    </div>
                                </div>
                                <div className="booking-info-wrapper margin">
                                    <div className="booking-date">
                                        <p> Basic Information</p>
                                    </div>
                                    <div className="space-details">
                                        <div className="Space-no">
                                            <p>Email: <span>{adminDetails.email}</span>
                                            <span style={{marginLeft:20}}>
                                                {adminDetails.email_verified == 0 ? 
                                                <span style={{color: '#38b1e4'}} className='cursorP' onClick={handleVerifyMail}>Please Verify</span> : 
                                                <img src={verified} />}</span>
                                            </p>
                                            <p>Phone : <span>{adminDetails.phone && adminDetails.country_code + ' ' +adminDetails.phone}</span>
                                                {adminDetails.phone &&  
                                                <span style={{marginLeft:20}}> 
                                                    {adminDetails.phone_verified == 0 ? 
                                                    <span style={{color: '#38b1e4'}}  className='cursorP' onClick={handleVerifyPhone}>Please Verify</span> : 
                                                    <img src={verified} />}
                                                </span>
                                                }
                                            </p>
                                            <p>Address: <span>{adminDetails.address}</span></p>
                                            {/* <p>Date of birth:<span> 07 June 1990</span></p> */}
                                            <p>Access code in profile</p>
                                        </div> 
                                    </div>
                                </div>
                                <div className="card-wrapper cursorP" onClick={() => {
                                    history.push(`/profile/vehicleList`)
                                }}>
                                    <div className="card-info">
                                        <div className="media">
                                            <div className="media-body">
                                                <h4>Added vehicles</h4>
                                                <p>Vehicle info</p> 
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="card-wrapper cursorP" onClick={() => {
                                    history.push(`/profile/cardList`)
                                }}>
                                    <div className="card-info">
                                        <div className="media">
                                            <div className="media-body">
                                                <h4>Saved cards</h4>
                                                <p>Saved payment methods</p> 
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="card-wrapper">
                                    <div className="card-info">
                                        <div className="media">
                                            <div className="media-body"> 
                                                <h4>
                                                <img className="mr-2" 
                                                src={CardIcon}/>
                                                <span>Notifications</span></h4> 
                                            </div>
                                        </div>
                                    </div> 
                                </div>
                                <div className="card-wrapper">
                                    <div className="card-info">
                                        <div className="media">
                                            <div className="media-body"> 
                                                <h4>
                                                <img className="mr-2" 
                                                src={CardIcon}/>
                                                <span>Push notifications</span></h4> 
                                            </div>
                                            <div className="push-noti">
                                                <img onClick={()=> setPushNoti(!pushNoti)} 
                                                src={pushNoti ? PushOnIcon : PushOffIcon} /> 
                                            </div>
                                        </div>
                                    </div> 
                                </div>
                                <div className="card-wrapper cursorP">
                                        <div className="card-info">
                                        <div className="media">
                                            <div className="media-body"> 
                                                <h4>
                                                <img className="mr-2" src={Iconfile} />
                                                <span>Terms of service</span></h4> 
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="card-wrapper cursorP">
                                    <div className="card-info">
                                        <div className="media">
                                            <div className="media-body"> 
                                                <h4>
                                                <img className="mr-2" 
                                                src={Iconfile} />
                                                <span>Security & privacy</span></h4> 
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="card-wrapper cursorP">
                                    <div className="card-info" onClick={() => history.push(`/report`)}>
                                        <div className="media">
                                            <div className="media-body"> 
                                                <h4>
                                                <img className="mr-2" 
                                                src={ReportIssueIcon} />
                                                <span>Report issue</span></h4> 
                                            </div>
                                            </div>
                                    </div>
                                </div>
                                <div className="card-wrapper cursorP">
                                    <div className="card-info" onClick={() => history.push(`/profile/changePassword`)}>
                                        <div className="media">
                                            <div className="media-body"> 
                                            <h4>
                                                <img className="mr-2" 
                                                src={ChangePasswordIcon} />
                                                <span>Change password</span></h4> 
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="card-wrapper cursorP">
                                    <div className="card-info">
                                        <div className="media">
                                            <div className="media-body"> 
                                                <h4>
                                                <img className="mr-2" 
                                                src={FaqsIcon} />
                                                <span>Faq</span></h4> 
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="card-wrapper cursorP">
                                    <div className="card-info">
                                        <div className="media">
                                            <div className="media-body"> 
                                                <h4 onClick={() => history.push(`/logout`)}>
                                                <img className="mr-2" 
                                                src={logout} />
                                                <span>Logout</span></h4> 
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>  
                    </div>
                </div>
            </div>
        </section>
    )
}
